import React, { useState } from "react";
import './csii.css';
const Csii = ({ titulo }) => {
  const [submenusCollapsed, setSubmenusCollapsed] = useState({ cepci: true, subMenu1: true, subMenu2: true, subMenu3: true });
  const handleCEPCIClick = () => {
    setSubmenusCollapsed({ ...submenusCollapsed, cepci: !submenusCollapsed.cepci });
  };
  const handleSubMenu1Click = () => {
    setSubmenusCollapsed({ ...submenusCollapsed, subMenu1: !submenusCollapsed.subMenu1 });
  };
  const handleSubMenu2Click = () => {
    setSubmenusCollapsed({ ...submenusCollapsed, subMenu2: !submenusCollapsed.subMenu2 });
  };
  const handleSubMenu3Click = () => {
    setSubmenusCollapsed({ ...submenusCollapsed, subMenu3: !submenusCollapsed.subMenu3 });
  };

  const [submenus1Collapsed, setSubmenus1Collapsed] = useState({ cocodi: true, subMenu1c: true, subMenu2c: true });
  const handleCOCODIClick = () => {
    setSubmenus1Collapsed({ ...submenus1Collapsed, cocodi: !submenus1Collapsed.cocodi });
  };
  const handleSubMenu1cClick = () => {
    setSubmenus1Collapsed({ ...submenus1Collapsed, subMenu1c: !submenus1Collapsed.subMenu1c });
  };
  const handleSubMenu2cClick = () => {
    setSubmenus1Collapsed({ ...submenus1Collapsed, subMenu2c: !submenus1Collapsed.subMenu2c });
  };
  return (
      <div className="container container-mh">
      <div className="titlesecundario">
        <h1>Sistema de Control Interno Institucional</h1>
        <br></br>                                    
        <p></p>
        <div className="contenido-button-group">
        <p></p>
        <button className="btn btn-primary contenido-button" type="button" onClick={handleCEPCIClick}>CEPCI</button>
        <div className={`multi-collapse collapse ${submenusCollapsed.cepci ? '' : 'show'}`} id="cepci-0">
        <p></p>
        <button className="btn btn-primary contenido-button" type="button" onClick={handleSubMenu1Click}>1.- Formato para quejas o denuncias 2024</button>
        <div className={`multi-collapse armo-collapse collapse ${submenusCollapsed.subMenu1 ? '' : 'show'}`} id="cepci-0-0">
        <p></p>
        <a href="../assets/PDF/Formato.pdf" target="_blank" className="btn btn-primary btn-armo-collapse btn-dorado">1.1 Descargar el formato de quejas</a>
        </div>
        <p></p>
        <button className="btn btn-primary contenido-button" type="button" onClick={handleSubMenu2Click}>2.- Procedimiento y Protocolo de Recepción y Atención a Quejas y Denuncias presentadas al Comité de Ética y Prevención de Conflictos de Interés.</button>
        <div className={`multi-collapse armo-collapse collapse ${submenusCollapsed.subMenu2 ? '' : 'show'}`} id="cepci-0-1">
        <p></p>
        <a href="../assets/PDF/Procedimiento.pdf" target="_blank" className="btn btn-primary btn-armo-collapse btn-dorado">2.1 Consulta el procedimiento</a>
        </div>
        <p></p>
        <button className="btn btn-primary contenido-button" type="button" onClick={handleSubMenu3Click}>3.- Pronunciamiento Protocolo Cero.</button>
        <div className={`multi-collapse armo-collapse collapse ${submenusCollapsed.subMenu3 ? '' : 'show'}`} id="cepci-0-2">
        <p></p>
        <a href="../assets/PDF/PRONUNCIAMIENTO CERO TOLERANCIA.pdf" target="_blank" className="btn btn-primary btn-armo-collapse btn-dorado">3.1 Consulta el Protocolo</a>
        </div>
      </div>
      </div>
      <br></br>
      <h5>Comité de Control y Desempeño Institucional</h5>
      <br></br>
      <p></p>
        <div className="contenido-button-group">
        <p></p>
        <button className="btn btn-primary contenido-button" type="button" onClick={handleCOCODIClick}>COCODI</button>
        <div className={`multi-collapse collapse ${submenus1Collapsed.cocodi ? '' : 'show'}`} id="cocodi-0">
        <p></p>
        <button className="btn btn-primary contenido-button" type="button" onClick={handleSubMenu1cClick}>1.- Código de Conducta de la Secretaría de Movilidad y Transporte</button>
        <div className={`multi-collapse armo-collapse collapse ${submenus1Collapsed.subMenu1c ? '' : 'show'}`} id="cocodi-0-0">
        <p></p>
        <a href="../assets/PDF/Código de Conducta SEMOT.pdf" target="_blank" className="btn btn-primary btn-armo-collapse btn-dorado">1.1 Consultar código</a>
        </div>
        <p></p>
        <button className="btn btn-primary contenido-button" type="button" onClick={handleSubMenu2cClick}>2.- Código de Ética de los Servidores Públicos</button>
        <div className={`multi-collapse armo-collapse collapse ${submenus1Collapsed.subMenu2c ? '' : 'show'}`} id="cocodi-0-1">
        <p></p>
        <a href="../assets/PDF/Código de Ética de los Servidores Públicos del Estado de Hidalgo.pdf" target="_blank" className="btn btn-primary btn-armo-collapse btn-dorado">2.1 Consulta el código</a>
        </div>
        <p></p>
       </div>
      </div>
    </div>
   </div>
  );
}
export default Csii;
